import dayjs from 'dayjs';
import { dayjsWithTimezone } from '../../src/utils';
import { PHYSICAL, TELECONSULTATION } from '@/src/constants';

// eslint-disable-next-line import/prefer-default-export
export const nearestAvailability = (
  closestAvailabilities,
  consultationType,
  timezone,
) => {
  if (!closestAvailabilities) {
    return;
  }
  const dayjsTZ = dayjsWithTimezone(timezone);
  const {
    closestPhysicalAvailability,
    closestTeleconsultationAvailability,
  } = closestAvailabilities;

  let closestDate;
  switch (consultationType) {
    case PHYSICAL:
      closestDate = closestPhysicalAvailability
        ? dayjsTZ(closestPhysicalAvailability.startDateTime)
        : null;
      break;
    case TELECONSULTATION:
      closestDate = closestTeleconsultationAvailability
        ? dayjsTZ(closestTeleconsultationAvailability.startDateTime)
        : null;
      break;
    default:
      if (
        closestAvailabilities?.availabilityCount === 0 ||
        (!closestPhysicalAvailability && !closestTeleconsultationAvailability)
      ) {
        closestDate = null;
        break;
      }

      if (closestPhysicalAvailability && closestTeleconsultationAvailability) {
        closestDate = dayjs.min(
          dayjsTZ(closestPhysicalAvailability.startDateTime),
          dayjsTZ(closestTeleconsultationAvailability.startDateTime),
        );

        break;
      }

      closestDate = dayjsTZ(
        (closestTeleconsultationAvailability || closestPhysicalAvailability)
          .startDateTime,
      );
      break;
  }
  return closestDate;
};
